import BaseUtil from "../../../util/BaseUtil";

const type = `@@ActionType/UPDATE@${__filename}`;

const tipMap = {
    "执业护士总人数": "系统内录入护士执业证，排除岗位属性为“非护理岗位”的护理人员总和",
    "住院病区执业护士总人数": "科室属性为“病区”的所有科室执业护士人数总和",
}

const initState = {
    initializing: true, // 初始化
    selectedUnitIds: null,
    unitsMap: null,
    natureOptions: null, // 职工性质选项
    options: null, // 查到的所有相关字典
    selectedNature: null, // 选中的职工性质
    quarterDate: null, // 选中的日期

    dataLoading: false,
    data: null, // 请求到的数据
    clickedItem: {
        title: null,
        category: null,
    }, // 点中的分类，统计表柱状图

    detailDrawerVisible: false, // 详情显隐
    detailDrawerData: null, // 详情数据
    detailDrawerLoading: false, // 详情加载
    clickedCell: {
        title: null, // 详情标题
        type: null, // 点中的类型
        category: null, // 点中的分类
    },

    statTableModalVisible: false, // 统计表可见
    statBarModalVisible: false, //  柱状图可见
    wardSettingDrawerVisible: false,
};

const [viewModel, update, reset] = BaseUtil.getViewModel(initState, type);

export {
    update,
    reset,
    tipMap,
};
export default viewModel;
